export default __webpack_public_path__ + "img/8918c0e78f424a7d4f15ba5b154aa9b3.svg";